import styled from "styled-components";

export const VoteTicketStyle = styled.div`
    .wrap {
        text-align: center;
    }
`